<template>
  <section v-if="isLoaded">
    <HeaderBackground :backgroundPath="`/${$staticPath}/${index.background}`"></HeaderBackground>
    <div class="content">
      <Header :headerText="index.headerText"></Header>
      <NewsList :filterProp="content.filter"></NewsList>
    </div>
  </section>
</template>

<script>
import HeaderBackground from '../COMMON/HeaderBackground.vue'
import Header from '../COMMON/Header.vue'
import NewsList from './NewsList.vue'

export default {
  components: {
    HeaderBackground,
    Header,
    NewsList
  },
  data () {
    return {
      index: {},
      content: {},
      isLoaded: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: async function () {
      if (this.$route.params.lang === 'en') {
        var index = await import('../../json/en/news/index.json')
        var content = await import('../../json/en/news/content.json')
      } else {
        index = await import('../../json/th/news/index.json')
        content = await import('../../json/th/news/content.json')
      }
      this.index = index
      this.content = content
      this.isLoaded = true
    }
  }
}
</script>

<style scoped>
  .content {
    background-color: #FFF;
    padding-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/News/Index.vue